module.exports = __webpack_public_path__ + "static/media/fresco.cdb9064e.jpg";